<template>
  <div class="logging-out">Logging out...</div>
</template>
<script>
export default {
  name: "Logout",
  mounted() {
    localStorage.removeItem("token");
    this.$store.dispatch("logout");
    this.$intercom.shutdown();
    document.location = "/login";
  }
};
</script>

<style lang="scss" scoped>
.logging-out {
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $bg-type-2;
}
</style>
